// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import { MAvatarProps } from './@material-extend/MAvatar';
import createAvatar from '../utils/createAvatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }: MAvatarProps) {
  const { user } = useAuth();

  // if (!user.photoURL) return null;

  return (
    <MAvatar
      src="/static/mock-images/avatars/avatar_default.svg"
      alt={user.email}
      color="default"
      /* src={user.photoURL || '/static/mock-images/avatars/avatar_default.svg'}
      alt={user.displayName}
      color={user.photoURL ? 'default' : createAvatar(user.displayName).color} */
      {...other}
    >
      {createAvatar(user.email).name}
    </MAvatar>
  );
}
